import image0 from './0.jpg';
import image1 from './1.jpg';
import image2 from './2.jpg';
import image3 from './3.jpg';
import image4 from './4.jpg';
import image5 from './5.jpg';
import image6 from './6.jpg';
import image7 from './7.jpg';
import image8 from './8.jpg';
import image9 from './9.jpg';
import image10 from './10.jpg';
import image11 from './11.jpg';
import image12 from './12.jpg';
import image13 from './13.jpg';
import image14 from './14.jpg';

const helperImages = () => [
  image0,
  image1,
  image2,
  image3,
  image4,
  image5,
  image6,
  image7,
  image8,
  image9,
  image10,
  image11,
  image12,
  image13,
  image14,
];

export default helperImages;



// WEBPACK FOOTER //
// ./src/reactModules/pages/Profile/components/Carousel/assets/fallBackImages/imageHelper.js